import i from "big.js";
import { wallet as o } from "../store/index.mjs";
import { commonOwner as c } from "../util/common.mjs";
import { getPendingReward as u } from "./staking_pool.mjs";
import { ERROR_CONNECT_WALLET as d } from "./errors.mjs";
import { useStakingPoolRewarderContract as e } from "../store/stakingPoolRewarderContract.mjs";
const R = c(e);
async function S() {
  return await e().claimDuration().then((t) => t.toString());
}
async function T() {
  return await e().claimStep().then((t) => t.toString());
}
async function D(...t) {
  return await e(!0).updateVestingSetting(...t);
}
async function y(...t) {
  return await e(!0).setRewardDispatcher(...t);
}
function V() {
  return e().rewardDispatcher();
}
function b() {
  return e().rewardToken();
}
function s(t) {
  const r = o?.getAddress();
  if (r === void 0) throw d;
  return e().calculateWithdrawableReward(r, t);
}
function k(t, r) {
  return e().calculateTotalReward(t, r);
}
function w() {
  return e().percentageToVestingSchedule();
}
async function C(t, r = w()) {
  const a = [
    u(t),
    r,
    s(t)
  ];
  return await Promise.all(a).then((n) => i(n[0].toString()).div(100).times(100 - Number(n[1])).plus(n[2].toString()).toFixed());
}
export {
  k as calculateTotalReward,
  s as calculateWithdrawableReward,
  S as claimDuration,
  T as claimStep,
  C as getReward,
  R as owner,
  w as percentageToVestingSchedule,
  V as rewardDispatcher,
  b as rewardToken,
  y as setRewardDispatcher,
  D as updateVestingSetting
};
//# sourceMappingURL=staking_pool_rewarder.mjs.map
